import { BillingInfoComponent } from './../checkout/components/billing-info.component';
import { PaymentComponent } from './../payment/components/payment.component';
import { CheckoutComponent } from './../checkout/components/checkout.component';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute, Params, Event as NavigationEvent, RoutesRecognized, NavigationEnd } from '@angular/router';
import { CustomObserverService } from '../../shared/index';
import { LocalStorageService } from 'angular-2-local-storage';
import { CookieNames } from '../constant';
declare var $: any;

@Component({
  selector: 'app-payment-flow',
  entryComponents: [CheckoutComponent, PaymentComponent], // Reference to the components must be here in order to dynamically create them
  templateUrl: './payment-flow.component.html'
})
export class PaymentFlowComponent implements OnInit {

  public totalPrice: number = 0;
  // kaushalya 2017-10-16 
  public pageTypemyBag: string = "MY_BAGE";
  public pageTypeBilling: string = "BILLING_INFORMATION";
  public pageTypePayment: string = "PAAYMENT";
  public pageTypeExam: string = "EXAM";
  public nextPagetype: string = this.pageTypemyBag;
  public backPagetype: string = this.pageTypemyBag;
  public currentPage : number ;
  componentData = null;
  public currentPaymentType : string;

  constructor(
    private router: Router,
    private customObserverService: CustomObserverService,
    private localStorageService : LocalStorageService,
  ) { 
    this.customObserverService.paymentFlowIcon$.subscribe(value => {
      this.currentPage = value;
    });
  }

  ngOnInit() {
    this.createCheckoutComponent();
    this.customObserverService.paymentFlowIcon$.subscribe(value => {
      this.currentPage = value;
    });
    this.currentPaymentType = this.localStorageService.get(CookieNames.PaymentModel)?  this.localStorageService.get(CookieNames.PaymentModel).toString() :'';

  }
  


  createPaymentComponent() {
    // add new next page
    this.nextPagetype = this.pageTypeExam; // need to change
    // add new back page
    this.backPagetype = this.pageTypeBilling;
    // add the active class
    this.changeClass(this.pageTypePayment);
    // change the back button label
    $('#backButton').text('Back');
    this.componentData = {
      component: PaymentComponent,
      inputs: {
        showNum: 9
      }
    };
  }

  createCheckoutComponent() {
    
    // add new next page
    this.nextPagetype = this.pageTypeBilling;
    // add new back page
    this.backPagetype = this.pageTypeExam; 
    // add the active class
    this.changeClass(this.pageTypemyBag);
    // change the back button label
    $('#backButton').text('Back to Shopping'); 
    this.componentData = {
      component: CheckoutComponent,
      inputs: {
        showNum: 2
      }
    };
  }

  createBillingInfoComponent() {
    
    // add new next page
    this.nextPagetype = this.pageTypePayment;
    // add new back page
    this.backPagetype = this.pageTypemyBag;
    // add the active class
    this.changeClass(this.pageTypeBilling);
    // change the back button label
    $('#backButton').text('Back');
    this.componentData = {
      component: BillingInfoComponent,
      inputs: {
        showNum: 2
      }
    };
  }

  /**
   * kaushalya
   * 2017-10-16
   * get next page
   */
  changeNextComponent() {
    if (this.nextPagetype == this.pageTypeBilling) { // for billing as next page
      this.createBillingInfoComponent();
    } else if(this.nextPagetype == this.pageTypePayment){ // for payment as next page
      this.createPaymentComponent();
    }else{
      this.router.navigate(['home/exams/']); // need to change
    }

  }

  /**
  * kaushalya
  * 2017-10-16
  * get back page cart-steps
  */
  changeBackComponent() {
    if (this.backPagetype == this.pageTypemyBag) { // for my bag as back page
      this.createCheckoutComponent();
    } else if(this.backPagetype == this.pageTypeBilling){ // for billing as back page
      this.createBillingInfoComponent();
    }else{
      this.router.navigate(['home/exams/']);// need to change
    }
  }

  /**
   * kauhsalya
   * 2017-10-16
   * to change the cart-steps class to active
   */
  changeClass(id) {
    $('.cart-steps').removeClass('active');
    $('#' + id).addClass('active');
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/payment-flow/payment-flow.component.ts